import { render, staticRenderFns } from "./StatsDailyDoubts.vue?vue&type=template&id=3af8d20d&"
import script from "./StatsDailyDoubts.vue?vue&type=script&lang=js&"
export * from "./StatsDailyDoubts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports